import React from "react";

export const AnalystImage = ({ imageURL, fullName, isThumbnail }) => {
  if (!imageURL) return null;

  return (
    <figure className="flex-shrink-0 overflow-hidden" style={isThumbnail && { height: "80px", width: "80px" }}>
      <img src={imageURL} alt={fullName + " photo"} className="d-block mx-auto" style={{ width: "80px" }}></img>
    </figure>
  );
};
